import { useAccountConfig } from '@/hooks/useAccountConfig';

/** Must-read posts live in the newsfeed, so both account switches have to be on. */
export const useMustReadsEnabled = (): boolean => {
  const { isFeatureEnabled } = useAccountConfig();
  return isFeatureEnabled('newsfeed') && isFeatureEnabled('mustReads');
};
